/**
 * user 模块信息
 */
import { getCookie, delCookie, setCookie } from '@/assets/js/util'; // cookie操作

export default {
  namespaced: true,
  state:{
    loginStatus:false,//登陆状态
    userinfo:null,//用户信息
  },
  mutations: {
    SET_LOGIN( state, bool ) {
      state.loginStatus = bool;
      if(bool){
        state.userinfo = JSON.parse(localStorage.getItem("sd_userInfo"));
      } else{
        state.userinfo = null;
        delCookie('member_token');
        localStorage.removeItem("sd_userInfo")
      }
    },
    SET_USERINFO( state, bool ) {
      state.loginStatus = true;
      state.userinfo = JSON.parse(localStorage.getItem("sd_userInfo"));
    },
  },
  actions: {

  },
  getters: {

  }
}
